export default __webpack_public_path__ + "static/media/offerPromo.56971dc9.svg";